import React from "react";
import Header from "../header";
import "./index.css";
import { FiGithub, FiLinkedin, FiTwitter } from "react-icons/fi";

const Layout: React.FC<any> = ({ children }) => {
  return (
    <div className="layout">
      <Header />
      {children}
      <div className="socials">
        <a
          href="https://github.com/rusty-jnr"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiGithub />
        </a>
        <a
          href="https://www.linkedin.com/in/nweke-ifeanyichukwu/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiLinkedin />
        </a>
        <a
          href="https://twitter.com/RustyJnr"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiTwitter />
        </a>
        <span />
      </div>
    </div>
  );
};

export default Layout;
